<template>
    <div class="col-lg-12 mt-3">
        <div class="row">
            <div class="col-lg-12 d-flex justify-content-end">
                <button v-show="pObjMovimientoAlmacen.Estatus== 'Pendiente' || (pOrigen=='SolicitudExtra')" @click="AbrirModal" class="btn btn-primary">Agregar Herramienta</button>
            </div>
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th v-if="pObjMovimientoAlmacen.Estatus!= 'EnTransito' || pOrigen=='SolicitudExtra'"></th>
                                <th>Nombre</th>
                                <th>Stock</th>
                                <th>Cantidad de Salida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in pObjMovimientoAlmacen.Herramientas" :key="index">
                                <td v-if="pObjMovimientoAlmacen.Estatus!= 'EnTransito' || pOrigen=='SolicitudExtra'">
                                    <button @click="EliminarHerramienta(item.IdArticuloAlmacen)" class="btn btn-danger">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                                <td style="width:70%">{{ item.Nombre }}</td>
                                <td>{{ pObjMovimientoAlmacen.IdMovimientoAlmacen==0 || pOrigen=='SolicitudExtra' ? item.Stock : item.Stock }}</td>
                                <td>{{ item.CantidadSalida }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'Herramientas',
    props:['pObjMovimientoAlmacen','pOrigen'],
    data() {
        return {
            objMovimientoAlmacen: {}
        }
    },
    methods: {
        EliminarHerramienta(Id)
        {
            let index = this.pObjMovimientoAlmacen.Herramientas.findIndex((element) => element.IdArticuloAlmacen == Id);
            this.pObjMovimientoAlmacen.Herramientas.splice(index,1);
        },
        AbrirModal(){
            this.bus.$emit('AbrirModalArticulo','Herramientas');
        }
    },
    created() {
        /* this.bus.$off('ArrayHerramientas');
        this.bus.$on('ArrayHerramientas',()=> {
            this.objMovimientoAlmacen = this.pObjMovimientoAlmacen;
        }); */
    },
}
</script>

<style>

</style>